import BaseRepository from '@/graphql/repositories/BaseRepository.js';

class UserPhoneRepository extends BaseRepository {
    static getModelName() {
        return 'UserPhone';
    }
}

export default UserPhoneRepository;
